import getSession from '@/api/getSession';
import { useQuery } from '@tanstack/react-query';
import { SessionResponse } from '@/types/api/api-v2';

function useSessionQuery() {
  const sessionQuery = useQuery<SessionResponse | null>({
    queryKey: ['session'],
    queryFn: getSession,
  });

  return {
    ...sessionQuery,
    data: sessionQuery.data || null,
  };
}

export { useSessionQuery };
